<template>
  <loading-page v-if="gettingPayment" />
  <div
    v-else
    class="row text-break"
  >
    <div class="col-12 col-lg-10 col-xl-8 m-auto">
      <div class="mb-2">
        <b-button
          variant="icon-light"
          class="shadow"
          @click="$router.push({ name: 'payments' })"
        >
          <GjIcon name="ArrowLeft" />
          Back
        </b-button>
      </div>
      <div class="d-flex flex-wrap align-items-center">
        <h3 class="text-main mr-1">
          {{ currencySymbol }}{{ calcPrice(payment.amount) }}
          <span class="text-thin text-uppercase">{{ payment.currency }}</span>
        </h3>
        <div>
          <span
            class="text-capitalize tag"
            :class="payment.status"
          >{{
            formatStatus(payment.status)
          }}</span>
        </div>
      </div>
      <div class="mt-2">
        <paper-simple>
          <div class="d-flex flex-wrap">
            <input-field
              label="Date"
              label-position="top"
              class="pr-1 pr-md-2 pr-lg-4"
            >
              {{ formatOffsetDateTime(payment.date) || '-' }}
            </input-field>
            <input-field
              label="Customer"
              label-position="top"
              class="pr-1 pr-md-2 pr-lg-4"
            >
              {{ payment.customer || '-' }}
            </input-field>
            <input-field
              label="Payment Method"
              label-position="top"
              class="pr-1 pr-md-2 pr-lg-4"
            >
              <span class="text-capitalize mr-05">{{
                payment.paymentMethod.brand || '-'
              }}</span>
              {{ ' •••• ' + payment.paymentMethod.last4 }}
            </input-field>
          </div>
        </paper-simple>

        <paper-simple>
          <div class="border-bottom">
            <p>
              Timeline
            </p>
          </div>
          <div class="mt-1 timeline">
            <div class="d-flex align-items-center mb-1">
              <div class="round">
                <GjIcon
                  v-if="payment.status === 'succeeded'"
                  name="Checkmark"
                  color="#36B37E"
                />
                <GjIcon
                  v-else-if="payment.status === 'processing'"
                  name="Loader"
                  color="#1d79f2"
                />
                <GjIcon
                  v-else-if="payment.status === 'requires_payment_method'"
                  name="InfoAlt"
                  color="#e34850"
                />
                <GjIcon
                  v-else
                  name="RefreshAlt"
                  color="#ffab00"
                />
              </div>
              <div class="timeline_item ml-1">
                <p>Payment {{ formatStatus(payment.status) }}</p>
                <label>{{
                  formatOffsetDateTime(payment.completedAt) || '-'
                }}</label>
              </div>
            </div>
            <div class="d-flex align-items-center mb-1">
              <div class="round">
                <GjIcon name="Payment" />
              </div>
              <div class="timeline_item ml-1">
                <p>Payment started</p>
                <label>{{ formatOffsetDateTime(payment.date) || '-' }}</label>
              </div>
            </div>
          </div>
        </paper-simple>

        <paper-simple>
          <p>
            Payment Details
          </p>
          <div class="row">
            <div class="col-12 col-lg-8">
              <b-form-group
                class="details mb-0"
                label="Amount"
                label-cols="12"
                label-cols-sm="4"
              >
                {{ currencySymbol }}{{ calcPrice(payment.amount) }}
              </b-form-group>
              <b-form-group
                class="details mb-0"
                label="Status"
                label-cols="12"
                label-cols-sm="4"
              >
                <span class="text-capitalize">{{
                  formatStatus(payment.status) || '-'
                }}</span>
              </b-form-group>
              <b-form-group
                class="details mb-0"
                label="Description"
                label-cols="12"
                label-cols-sm="4"
              >
                <span class="text-capitalize">{{
                  payment.description || '-'
                }}</span>
              </b-form-group>
            </div>
          </div>
        </paper-simple>
      </div>
    </div>
  </div>
</template>
<script>
import currencies from '../currencies'

export default {
  name: 'PaymentDetails',
  data() {
    return {
      id: '',
      currencies,
    }
  },
  computed: {
    payment() {
      return this.$store.state.payments.payment
    },
    gettingPayment() {
      return this.$store.state.payments.gettingPayment
    },
    currencyName() {
      const el = this.currencies.find(
        element => element.code === this.payment.currency,
      )
      return el ? el.name : this.payment.currency
    },
    currencySymbol() {
      const el = this.currencies.find(
        element => element.code === this.payment.currency,
      )
      return el ? el.symbol : this.payment.currency
    },
  },
  created() {
    this.id = this.$route.params.id
    this.$store.dispatch('payments/getPayment', this.id)
  },
  methods: {
    formatStatus(s) {
      return s.replaceAll('_', ' ')
    },
    calcPrice(val) {
      return (val / 100).toLocaleString()
    },
  },
}
</script>
<style lang="scss" scoped>
.back {
  @media (min-width: 992px) {
    position: absolute;
  }
}
.tag {
  box-sizing: border-box;
  border-radius: 20px;
  padding: 2px 8px;
  color: var(--white);
  font-weight: bold;
  &.succeeded {
    background: var(--success);
    border: 1px solid var(--success);
  }
  &.processing {
    background: var(--primary);
    border: 1px solid var(--primary);
  }
  &.requires_action,
  &.requires_confirmation {
    background: var(--warning);
    border: 1px solid var(--warning);
  }
  &.requires_payment_method {
    background: var(--danger);
    border: 1px solid var(--danger);
  }
}
.mr-05 {
  margin-right: 5px;
}

.details::v-deep {
  .form-row {
    align-items: center;
  }
  legend {
    color: #667c99;
    font-weight: 400;
  }
}
.timeline {
  position: relative;
  margin-left: 0;
  &::before {
    position: absolute;
    content: '';
    height: 73%;
    width: 1px;
    background: #e0e5eb;
    left: 16px;
    top: 17%;
  }
  .round {
    position: relative;
    display: flex;
    align-items: center;
    width: 32px;
    height: 32px;
    justify-content: center;
    background: #f6f7f9;
    border: 1px solid #e0e5eb;
    min-width: 32px;
  }
  .timeline_item {
    p {
      margin-bottom: 5px;
    }
  }
}
</style>
